import { enqueueSnackbar } from "notistack";
import { useMemo } from "react";
import { fetcher } from "src/utils/axios";
import useSWR from "swr";
const options = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
};
export function useFetch(URL) {
    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, options);

    const memoizedValue = useMemo(
        () => ({
            payload: data?.payload || [],
            loading: isLoading,
            error: error,
            validating: isValidating,
            empty: !isLoading && !data?.payload.length,
        }),
        [ data?.contacts, error, isLoading, isValidating ]
    );

    return memoizedValue;
}


export function getDropdownsId(array, value) {
    const foundItem = array?.find((item) => item.name === value);
    return foundItem ? foundItem.id : undefined;
}

export function dateFormatter(date) {
    if (!date) {
        return "";
    }
    const newDate = new Date(date);
    const formattedDate = newDate.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
    const formattedDateWithDashes = formattedDate.replace(/\//g, '-');
    return formattedDateWithDashes;
}

export function timeFormatter(date) {
    if (!date) {
        return "";
    }
    const newDate = new Date(date);
    return newDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}



export function dateFormattertime(date) {
    if (!date) return "";

    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");
    const hours = String(newDate.getHours()).padStart(2, "0");
    const minutes = String(newDate.getMinutes()).padStart(2, "0");
    const seconds = String(newDate.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}




export function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export const handleErrorMessages = (message) => {
    if (typeof message === 'object') {
        const errorMessageArray = Object.values(message).flatMap((messages) => messages);
        errorMessageArray.forEach((msg) =>
            enqueueSnackbar({
                variant: 'error',
                message: msg,
            })
        );
    } else if (Array.isArray(message)) {
        message.forEach((msg) =>
            enqueueSnackbar({
                variant: 'error',
                message: msg,
            })
        );
    } else if (message) {
        enqueueSnackbar({
            variant: 'error',
            message: message,
        });
    }
};

export function applyFilter({ inputData, comparator, filters }) {
    const { name, role, status } = filters;

    const stabilizedThis = inputData?.map((el, index) => [ el, index ]);

    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[ 0 ], b[ 0 ]);
        if (order !== 0) return order;
        return a[ 1 ] - b[ 1 ];
    });

    inputData = stabilizedThis?.map((el) => el[ 0 ]);

    if (name) {
        const searchTerm = name.toLowerCase();
        inputData = inputData?.filter((user) => JSON.stringify(user).toLowerCase().includes(searchTerm));
    }
    if (role.length) {
        inputData = inputData?.filter((user) => role?.includes(user.plan));
    }
    if (status !== 'all') {
        inputData = inputData?.filter((user) =>
            (status === "active" && user.active === true) ||
            (status === "inactive" && user.active === false)
        );
    }

    return inputData;
}

